import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'header-waves-container',
    templateUrl: './header-waves-container.component.html',
    styleUrls: ['./header-waves-container.component.scss'],
    standalone: false
})
export class HeaderWavesComponent {
  @Input()
  customText: string;
  @Input()
  dataInizio: string;
  @Input()
  dataFine: string;
  @Input()
  otherText: string;
  @Input()
  dalText: string;
  @Input()
  alText: string;
  @Input()
  timer: boolean;
  @Input()
  timeOutLabel: string;
  @Input()
  className: string = "header safe--area";
  @Input()
  paginaProvenienza: string = 'mainpage';
  @Input()
  showBackButton: boolean;
  @Input()
  passaFunzioneParent: boolean = false;
  @Input()
  iconName: string = 'arrow-back-outline';
  @Output('clickFunction') callBackFunc: EventEmitter<any> = new EventEmitter();

  constructor() { }

  parentFunction(): void {
    this.callBackFunc.emit();
  }

}
